import { render, staticRenderFns } from "./ParticipantHandleDuplicatePopup.vue?vue&type=template&id=5e4d638a&"
import script from "./ParticipantHandleDuplicatePopup.vue?vue&type=script&lang=js&"
export * from "./ParticipantHandleDuplicatePopup.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantHandleDuplicatePopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports